import McmSoldConfig from '~/tenants/mcm/performable/sold/McmSoldConfig';
import McmJob from '~/tenants/mcm/model/McmJob';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { TenantJobLine } from '~/lib/model';
import { Big } from 'big.js';
import { DeliverableType } from '~common/model/Deliverable';
import { PersonaType } from '~/tenants/common/TenantPersona';

export default class McmSoldJob extends McmJob<typeof McmSoldConfig> {
  get performable() {
    return McmSoldConfig;
  }

  get deliverable() {
    return DeliverableType.PHOTO;
  }

  get media() {
    return PersonaType.PROVIDER;
  }

  defaultValue(): ZodVersionedMetadata<(typeof McmSoldConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
    };
  }

  revenueLines(): TenantJobLine[] {
    const lines: TenantJobLine[] = [];

    lines.push({
      id: 'photo',
      description: 'Just Sold Photo',
      amount: new Big('50'),
    });

    return lines;
  }

  get minimumPhotos(): number {
    return 1;
  }
}
